module.exports = __webpack_public_path__ + "static/media/hero.5a630cfe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/marmalade/hero.jpg
// module id = 261
// module chunks = 0